import '../../Pages/Client/Cvtheque/CvTheque.scss';

import { Add } from '@mui/icons-material';
import CloseIcon from '@mui/icons-material/Close';
import { AppBar, Button, Dialog, FormControl, FormControlLabel, IconButton, Radio, RadioGroup, Toolbar } from '@mui/material';
import { ThemeProvider } from '@mui/styles';
//import moment from 'moment';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { dureeBdcEnum } from '../../data/Interfaces';
import useAxiosPrivate from '../../hooks/useAxiosPrivate';
import useFormValidation, { champRequisString } from '../../hooks/useFormValidation';
import usePostRequest from '../../hooks/usePostRequest';
import useUtilities from '../../hooks/useUtilities';
import useWindowSize from '../../hooks/useWindowSize';
import { FieldComponentFont } from '../../Styles/componentStyles';
import { calculateWorkingDaysBetweenDates, extractValue } from '../../Utils/utils';
import { buttonStyles, buttonStylesGreen } from '../docsAdministrative/JsObjectStyles';
import RegimeModeTravail from '../shared/RegimeModeTravail';
import { DatePickerComponent, IconTextField, SelectComponent, TextFieldComponent, Transition } from '../shared/ReusableSmallComponents';
import SearchCity from '../shared/SearchCity';

// export const handleActionOnDialogwhichWillCloseItAndDisplayMessage = ({ message, handleClose }) => {
//     const { setBackdropOpen, setOpenSnackBar, setSnackBarMessage } = useUtilities();
//     setBackdropOpen(true);
//     setSnackBarMessage(message);
//     handleClose();
//     setBackdropOpen(false);
//     setOpenSnackBar(true);
// };
function DialogClasserCvs({ selectedExperts, openClasser, handleCloseClasser }) {
    DialogClasserCvs.propTypes = {
        selectedExperts: PropTypes.any,
        openClasser: PropTypes.any,
        handleCloseClasser: PropTypes.func,
    };
    //! hooks rule : call a hook only inside a functionnal component, don't try to create a function to prevent DRY ..
    const { setShowErrors, setErrors , errors} = useUtilities();
    const { postData } = usePostRequest();
    const axiosPrivate = useAxiosPrivate();
    const [isDossierExists, setIsDossierExists] = useState(true);
    const [dossierId, setDossierId] = useState('');
    const [dossierName, setDossierName] = useState('');
    const [allDossiers, setAllDossiers] = useState([]);
    const { i18n } = useTranslation();
    const {device}=useWindowSize();
    const Ids = extractValue(selectedExperts, 'id'); //was _id, but _id now holds {$oid: "638655b07f4589a611bf9167"} and I can't simply change it because it will be overridden by ...expert?.expertData
    const [modeTravail, setModeTravail] = React.useState({
        type: '',
        nbJrsRemotePerWeek: '',
    });
    const [regimeTravail, setRegimeTravail] = React.useState({
        type: '',
        nbJrsPartielPerWeek: '',
    });
    const [localisation, setLocalisation] = useState();
    const [tjMax, setTjMax] = useState(0);
    const [dateDebutMission, setDateDebutMission] = useState(null);
    const [dateFinMission, setDateFinMission] = useState(null);
    const [dureeMission, setDureeMission] = useState(0);
    const [dureeBDC, setDureeBDC] = useState();
    const [isValid] = useFormValidation([
        { name: 'dossierName', value: dossierName },
    ]);
    useEffect(() => {
        if (dateDebutMission !== null && dateFinMission !== null) {
            setDureeMission(calculateWorkingDaysBetweenDates(dateDebutMission, dateFinMission, regimeTravail.nbJrsPartielPerWeek));
        }
    }, [dateDebutMission, dateFinMission, regimeTravail.nbJrsPartielPerWeek]);
    const getAllMyDossiers = async () => {
        try {
            const response1 = await axiosPrivate.get('/cvTheque/getAllMyDossiers');
            // const responseData1 = await response1.data;
            setAllDossiers(response1.data);
        } catch (error) {
            console.log(error.response?.status, error.response?.data.error);
        }
    };
    const linkCv2Dossier = async () => {
        try {
            postData({
                url: '/cvTheque/linkCv2Dossier', payload: {
                    dossierId, expertIds: Ids
                }
            });
            resetDataAndClose();
        } catch (error) {
            console.log(error.response?.status, error.response?.data.error);
        }
    };

    const createDossier = async () => {
        try {
            postData({
                url: '/cvTheque/createDossier', payload: {
                    nom: dossierName, expertIds: Ids,
                    localisation, tjMax, dateDebutMission,
                    dateFinMission, dureeMission, dureeBDC,
                    modeTravail, regimeTravail
                }
            });
            resetDataAndClose();
        } catch (error) {
            console.log(error.response?.status, error.response?.data.error);
        }
    };
    // get Initial Data
    React.useEffect(() => {
        console.log(openClasser);
        if (openClasser)
            getAllMyDossiers();
    }, [openClasser]);
    console.log({ selectedExperts, isDossierExists, Ids });
    const scroll='paper';
    const resetDataAndClose = () => {
        setIsDossierExists(true);
        setDossierId('');
        setDossierName('');
        setAllDossiers([]);
        setModeTravail({
            type: '',
            nbJrsRemotePerWeek: '',
        });
        setLocalisation();
        setRegimeTravail({
            type: '',
            nbJrsPartielPerWeek: '',
        });
        setTjMax(0);
        setDateDebutMission(null);
        setDateFinMission(null);
        setDureeMission(0);
        setDureeBDC();
        handleCloseClasser();
    };
    return (
        <Dialog
            fullScreen
            open={openClasser}
            TransitionComponent={Transition}
            onClose={resetDataAndClose}
            scroll={scroll}
            PaperProps={{
                style: {
                    background: '#F5F6FA',
                },
            }}
            aria-labelledby="scroll-dialog-title"
            aria-describedby="scroll-dialog-description"
        >
            <AppBar>
                <Toolbar>
                    <IconButton
                        edge="start"
                        color="inherit"
                        onClick={resetDataAndClose}
                        aria-label="close"
                    >
                        <CloseIcon />
                    </IconButton>
                </Toolbar>
            </AppBar>
            <form style={{display:'flex',background: '#F5F6FA',paddingTop: '150px',justifyContent:'center',width:'100%'}}>
                <div className='frame14Modified4ClasserCvTheque'>
                    <h4 className='titlesociete'>{i18n.t('Classer les CV sélectionnés dans un dossier')}</h4>
                    <FormControl style={{display:'flex',gap:'12px',alignSelf:'stretch'}}>
                        <RadioGroup
                            aria-labelledby="demo-controlled-radio-buttons-group"
                            name="controlled-radio-buttons-group"
                            value={isDossierExists}
                            // * still the best way to convert a string to a boolean
                            onChange={(e) => setIsDossierExists((e.target.value === 'true'))}
                            style={{display: 'flex', flexDirection: device=='desktop' ?'row':'column', gap: '16px',width:'100%'}}

                        >
                            <div
                                style={{
                                    boxSizing: 'border-box',
                                    alignItems: 'center',
                                    display:'flex',
                                    padding: '8px 16px',
                                    gap: '4px',
                                    width: device=='desktop' ?'48%':'100%',
                                    height: '56px',
                                    borderRadius: '8px',
                                    background: '#FFFFFF',
                                    border: '1px solid #9D9E9F',
                                }}
                            >
                                <ThemeProvider theme={FieldComponentFont}>
                                    <FormControlLabel
                                        value={true}
                                        control={<Radio />}
                                        style={{width:'100%'}}
                                        label={i18n.t('Dossier existant')}
                                        // disabled={role=='admin' ? true : false}
                                    />
                                </ThemeProvider>
                            </div>
                            <div
                                style={{
                                    boxSizing: 'border-box',
                                    alignItems: 'center',
                                    padding: '8px 16px',
                                    display:'flex',
                                    gap: '4px',
                                    width: device=='desktop' ?'48%':'100%',
                                    height: '56px',
                                    borderRadius: '8px',
                                    background: '#FFFFFF',
                                    border: '1px solid #9D9E9F',
                                }}
                            >
                                <ThemeProvider theme={FieldComponentFont}>
                                    <FormControlLabel
                                        value={false}
                                        control={<Radio />}
                                        label={i18n.t('Nouveau dossier')}
                                        style={{width:'100%'}}
                                        // disabled={role=='admin' ? true : false}
                                    />
                                </ThemeProvider>
                            </div>
                            {isDossierExists &&
                                    <>
                                        <SelectComponent
                                            placeholder={i18n.t('nom dossier')}
                                            val={dossierId}
                                            setVal={(e) => setDossierId(e.target.value)}
                                            listVal={allDossiers.map((dossier)=> { return {
                                                value: dossier?._id,
                                                label: dossier.nom
                                            }; }) }
                                        />
                                        {/*<Select
                                            placeholder='nom dossier'
                                            style={{ backgroundColor: 'white' }}
                                            sx={{
                                                width: '1093px'
                                                //'& > :not(style)': { width: '435px'},
                                                //'MuiPaper-root':{
                                                //    width: '435px'}
                                            }}
                                            value={dossierId}
                                            onChange={(e) => setDossierId(e.target.value)}
                                        >
                                            {allDossiers.map((dossier) => (
                                                <MenuItem
                                                    key={dossier._id}
                                                    value={dossier._id}
                                                >{dossier.nom}
                                                </MenuItem>
                                            ))}
                                        </Select>*/}
                                    </>}
                            {!isDossierExists &&
                                    <div style={{display:'flex',flexDirection:'column',gap:'8px',width:'100%'}}>
                                        <h6 className='nomPrenomProfile'>{i18n.t('Informations du dossier')}</h6>
                                        <IconTextField
                                            //id="outlined-name"
                                            //label="Nom"
                                            placeholder={i18n.t('Entrer le Nom du dossier')}
                                            style={{width:'100%', borderRadius:'8px',background:'white'}}
                                            sx={{
                                                '& > :not(style)': { borderRadius:'8px' },
                                            }}
                                            iconEnd={<Add />}
                                            //InputProps={{
                                            //    endAdornment: (
                                            //        <div className='iconStyleStartAdornment iconStyleEndAdornment'>
                                            //            <InputAdornment position="end">
                                            //                <Add />
                                            //            </InputAdornment>
                                            //        </div>
                                            //    ),
                                            //}}
                                            name='dossierName'
                                            value={dossierName}
                                            onChange={(e) => setDossierName(e.target.value)}
                                            autoComplete='off'
                                        //endIcon={<AddIcon />}
                                        />
                                        <h6 className='nomPrenomProfile'>{i18n.t('Informations supplémentaires')}</h6>
                                        <RegimeModeTravail
                                            setModeTravail={setModeTravail}
                                            setRegimeTravail={setRegimeTravail}
                                            modeTravail={modeTravail}
                                            regimeTravail={regimeTravail}
                                        />
                                        <div className='Frame101292323112'>
                                            <p  className='IntitulePoste'>{i18n.t('Localisation')} </p>
                                            <SearchCity
                                                // style={{
                                                //     position: 'relative',
                                                //     top: '-18px'
                                                // }}
                                                width='100%'
                                                setCity={setLocalisation}
                                                city={localisation}
                                            />
                                        </div>
                                        <div className='Frame101292323112'>
                                            <p  className='IntitulePoste'>{i18n.t('Budget maximum/jour (en €)')}</p>
                                            <TextFieldComponent
                                                style={{width:'100%',borderRadius:'8px',background:'white'}}
                                                sx={{
                                                    '& > :not(style)': {
                                                        borderRadius: '8px',
                                                    },
                                                }}
                                                type="number"
                                                min="0"
                                                name="tj"
                                                placeholder={i18n.t('Entrer le Taux journalier')}
                                                autoComplete="off"
                                                value={tjMax}
                                                onChange={(e) => setTjMax(e.target.value)}
                                            />
                                            {/* <p className='IntitulePoste'>Equivalent par mois</p>
                                                        <TextFieldComponent
                                                            style={{height: '56px'}}
                                                            sx={{
                                                                '& > :not(style)': { width: '538.5px',borderRadius: '8px', marginTop: '-19px'},
                                                            }}
                                                            type="number"
                                                            min="0"
                                                            name="tj"
                                                            placeholder="Entrer le Taux journalier "
                                                            autoComplete="off"
                                                            value={Number(tjMax) * 21}
                                                            disabled
                                                        /> */}
                                        </div>
                                        <div className='Frame101292323112'>
                                            <p  className='IntitulePoste'>{i18n.t('Date de début (mission)')}</p>
                                            <DatePickerComponent
                                                label=""
                                                date={dateDebutMission}
                                                setDate={(newValue) => {
                                                    setDateDebutMission(newValue);
                                                }}
                                                width={'100%'}
                                                disablePast
                                            />
                                        </div>
                                        <div className='Frame101292323112'>
                                            <p  className='IntitulePoste'>{i18n.t('Date estimée de fin (mission)')}</p>
                                            <DatePickerComponent
                                                label=""
                                                date={dateFinMission}
                                                setDate={(newValue) => {
                                                    setDateFinMission(newValue);
                                                }}
                                                width={'100%'}
                                                disablePast
                                            />
                                        </div>
                                        <div className='Frame101292323112'>
                                            <p  className='IntitulePoste'>{i18n.t('Durée de mission')}</p>
                                            <TextFieldComponent
                                                style={{ borderRadius:'8px',background:'white',width:'100%'}}
                                                sx={{
                                                    '& > :not(style)': {borderRadius: '8px' },
                                                }}
                                                type="number"
                                                name="dureeMission"
                                                value={dureeMission}
                                                // readOnly
                                                //autoComplete="off"
                                                //min="0"
                                                onChange={(e) => setDureeMission(e.target.value)}
                                            />
                                        </div>
                                        <div className='Frame101292323112'>
                                            <p  className='IntitulePoste'>{i18n.t('Durée du BDC')}</p>
                                            <SelectComponent
                                                val={dureeBDC}
                                                setVal={ (e) => setDureeBDC(e.target.value)}
                                                listVal={dureeBdcEnum}
                                            />
                                        </div>
                                    </div>}
                        </RadioGroup>
                        <div style={{display:'flex',flexDirection:device=='desktop' ? 'row':'column',alignSelf:'stretch',justifyContent:'flex-end'}}>
                            <Button
                                variant='text'
                                style={{...buttonStyles(),
                                    ...{width:device=='desktop' ? '118px':'100%'}
                                }}
                                onClick={resetDataAndClose}
                            >{i18n.t('Annuler')}</Button>
                            <Button
                                variant='contained'
                                style={{...buttonStylesGreen(false),...{width: device=='desktop' ?'111px':'100%'}}}
                                type='submit'
                                onClick={(e) => {
                                    e.preventDefault();
                                    if (regimeTravail.type == 'temps-partiel' && !isDossierExists) {
                                        if (isNaN(parseFloat(regimeTravail.nbJrsPartielPerWeek))){
                                            setErrors({...errors, ...{nbJrsPartielPerWeek: champRequisString}});
                                            setShowErrors(true);
                                        }
                                    }
                                    else if (isValid && !isDossierExists) {
                                        createDossier();
                                        resetDataAndClose();
                                        setShowErrors(false);
                                        setErrors({});
                                    }
                                    else if(isDossierExists){
                                        linkCv2Dossier();
                                    }
                                    else if(!isValid){
                                        setErrors({...errors, ...{nbJrsPartielPerWeek: ''}});
                                        setShowErrors(true);
                                    }
                                }}
                            >
                                {i18n.t('Classer')}
                            </Button>
                        </div>
                    </FormControl>
                </div>
            </form>
        </Dialog>
    );
}

export default DialogClasserCvs;
